import { makeObservable } from 'mobx';
import { BaseNotificator } from '../../../../../../main-service/logic/shared/notifications/BaseNotificator';

class LoginNotificator extends BaseNotificator {
  constructor() {
    super();

    makeObservable(this, {});
  }
}

export { LoginNotificator };
